import React from 'react';
import Skeleton from 'react-skeleton-loader';
import { Card, CardImg, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import configs from 'configs';
import './styles/carItem.scss';


const SkeletonCarItem = () => {
  return (
    <div className="Car">
      <Link to={`/offers`} className="el-tablo">
        <div className={'CarItem'}>
          <Card>
            <div className={'car-price-row'}>
              <div className={'car-white-label'}/>
              <div className={'d-flex flex-column text-right'}>
                <div className={'car-price'}>
                  <Skeleton />
                  <span className={'car-price-desc'}/>
                </div>
                <p className={'car-price-vat'}/>
              </div>
            </div>
            <CardBody>
              <CardImg
                className={'img-fluid'}
                width="100%"
                src={`${configs.cdnHost}/cars/generic_shape.png`}
                alt={`Immagine `}
              />
            </CardBody>
            <div className={'car-name'}><Skeleton width="11vw"/><Skeleton width="15vw"/></div>
            <div className={'car-extra-info'}>
              <ul>
                <li>&nbsp;</li>
              </ul>
            </div>
          </Card>
        </div>
      </Link>
    </div>
  );
};

export default SkeletonCarItem;
